import { render, staticRenderFns } from "./ContactsPanel.vue?vue&type=template&id=4f08d763&"
import script from "./ContactsPanel.vue?vue&type=script&lang=js&"
export * from "./ContactsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports